import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePrioritys, Priority } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Priority>
      useData={usePrioritys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
